import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  TextField,
  Stack,
  Grid,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { getSuppliesDetail as getSuppliesDetailFetch } from "../../core/services/suppliesDetail/suppliesDetail.service";
import "./ManagementsContractEnd.scss";
import { useTranslation } from "react-i18next";
import ManagementHeader from "../ManagementsUpdate/ManagementsUpdateHeader/ManagementsUpdateHeader";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import {
  ContractEndReferenceData,
  ManagementRequestInfo,
  PostCallCenterRequestBody,
  RequestStateDescriptionData,
} from "../../core/models/managements/managements.model";
import ButtonElement from "../UI/ButtonElement/ButtonElement";
import {
  FormattedOwnerData,
  OwnerDataCups,
} from "../../core/models/ownerData/ownerData.model";
import {
  fetchBipValidation,
  postCallCenter as postCallCenterFetch,
  postImportDocument,
} from "../../core/services/managements/managements.service";
import ConsumptionsManagementsDeliveryAddressComponent from "../ConsumptionsManagementsDeliveryAddressComponent/ConsumptionsManagementsDeliveryAddressComponent";
import { initialOwnerDataCup } from "../../utils/ownerData/ownerData.util";
import ManagementsRequestState from "../Managements/ManagementsRequestState/ManagementsRequestState";
import ManagementUploadFile from "../Managements/ManagementsUploadFile/ManagementsUploadFile";
import {
  getBase64,
  getManagementsRequestTypeData,
  getRegisterTypeId,
  initialManagementRequestInfo,
} from "../../utils/components/managements/managements.util";
import {
  MANAGEMENTS_REGISTER_TYPE_REQUEST,
  MANAGEMENTS_STATE_ERROR,
  MANAGEMENTS_STATE_PENDING,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
} from "../../core/constants/constants";
import { formatDate } from "../../utils/dateUtils/formatDate.util";
import ManagementsCancelProcess from "../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import { getRecipientId } from "../../utils/components/services/services.util";
import SingleDatePicker from "../UI/SingleDatePicker/SingleDatePicker";
import dayjs from "dayjs";
import { CustomDateError } from "../../core/models/datePickersComponent/datePickersComponent.model";
import { useSingleDatePickerValidation } from "../../utils/components/datePickers/datePickers.utils";
import {
  CupsDetail,
  GetSuppliesDetailRequestBody,
} from "../../core/models/suppliesDetail/suppliesDetail.model";
import ManagementsContractEndModal from "./ManagementsContractEndModal/ManagementsContractEndModal";
import useProcessedOwnerData from "../../utils/components/managements/processedOwnerData/useProcessedOwnerData";
import useOcrValidation from "../../utils/components/managements/ocrValidation/useOcrValidation";

const ManagementsContractEnd = () => {
  const { t } = useTranslation();
  const { ownerData, userData, isAgent, cifCupsState } =
    useContext(TotalEnergiesContext);

  const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
    useState<OwnerDataCups>(initialOwnerDataCup);
  const [managementRequestInfo, setManagementRequestInfo] =
    useState<ManagementRequestInfo>(initialManagementRequestInfo);
  const [step, setStep] = useState<number>(0);
  const [isClaimLoading, setIsClaimLoading] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<string>("");
  const [requestStateData, setRequestStateData] =
    useState<RequestStateDescriptionData>({
      title: "",
      description: "",
      descriptionExtra: "",
    });
  const [file, setFile] = useState<File | null>(null);
  const [contractEndDetail, setcontractEndDetail] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [checkBoxRadioValue, setCheckBoxRadioValue] = useState<string>("");
  const [appliedDay, setAppliedDay] = useState<dayjs.Dayjs | null>(null);
  const { error, setError } = useSingleDatePickerValidation();
  const [ocrError, setOcrError] = useState<
    "response_ko" | "server_error" | null
  >(null);
  const [isOcrLoading, setIsOcrLoading] = useState<boolean>(false);
  const [supplyData, setSupplyData] = useState<CupsDetail | null>(null);
  const { processedOwnerData } = useProcessedOwnerData({
    isAgent,
    ownerData,
    cifCupsState,
  });

  const { formatOcrErrorMessage, ocrErrorMessage, setOcrErrorMessageKeys } =
    useOcrValidation();

  // remove inactive contracts
  const filteredCups = processedOwnerData?.cups.filter((item) => {
    const contractSituation = isAgent
      ? item.situation
      : item.contractSituationDetail;
    return contractSituation === "Contrato" || contractSituation === "Cortado";
  });

  const appliedDayData = [
    {
      id: "asap",
      label: "Cuanto antes",
      value: "asap",
    },
    {
      id: "selectDate",
      label: "Seleccionar fecha",
      value: "selectDate",
    },
  ];

  const maxDate = dayjs().add(30, "day");
  const isDatePickerDisabled = checkBoxRadioValue !== "selectDate";

  const customDateError: CustomDateError[] = [
    {
      errorType: "maxDate",
      text: t("Datepicker.Debe indicar una fecha válida 30 días"),
    },
  ];

  useEffect(() => {
    const isFileSelected = file !== null;
    const isAddressSelected = selectedDeliveryAddress.idCups;

    const checkIsButtonDisabled =
      !(isFileSelected && isAddressSelected) ||
      !!!checkBoxRadioValue.length ||
      (checkBoxRadioValue === "selectDate" && !appliedDay) ||
      !!ocrError;

    setIsButtonDisabled(checkIsButtonDisabled);
  }, [selectedDeliveryAddress, file, appliedDay, checkBoxRadioValue, ocrError]);

  const handleSendContractEnd = () => {
    if (processedOwnerData && userData) {
      postCallCenter(contractEndDetail, selectedDeliveryAddress);
    }
  };

  const handleValidateFile = () => {
    if (processedOwnerData && userData) {
      getDocumentValidation(selectedDeliveryAddress);
    }
  };

  const suppliesDetailsAbortController = new AbortController();

  const getSuppliesDetail = async (
    token: string,
    abortSignal: AbortSignal,
    { isAdministrator, idClient, idAdministrator }: FormattedOwnerData,
    idCups?: string,
    contractId?: string,
  ) => {
    const getSuppliesRequestBody: GetSuppliesDetailRequestBody = {
      userid: isAdministrator ? (idAdministrator ?? "") : (idClient ?? ""),
      isAdmin: isAdministrator?.toString() ?? "",
      cupsContractId: contractId?.toString() ?? "",
      cupsId: idCups ?? "",
    };

    try {
      const suppliesDetail = await getSuppliesDetailFetch(
        getSuppliesRequestBody,
        token,
        abortSignal,
      );
      setSupplyData(suppliesDetail);
      return suppliesDetail;
    } catch {
      console.error("Couldn't fetch supplies details");
    }
  };

  const getDocumentValidation = async (
    ownerDataCupSelected: OwnerDataCups,
  ): Promise<void> => {
    const { idContract, socialReason, codeCups, cif, address, town, idCups } =
      ownerDataCupSelected;

    if (userData) {
      // validate document with ocr service

      const appliedDayFormatted =
        checkBoxRadioValue === "asap"
          ? "Cuanto antes"
          : appliedDay
            ? formatDate(appliedDay?.toDate())
            : "";

      try {
        setIsOcrLoading(true);

        let suppliesDetail: CupsDetail | null = supplyData || null;

        if (processedOwnerData && !!!supplyData) {
          suppliesDetail =
            (await getSuppliesDetail(
              userData.token,
              suppliesDetailsAbortController.signal,
              processedOwnerData,
              idCups,
              idContract,
            )) || null;
        }

        const splitAddress = address.split(", ");

        const ocrValidationRequestBody: ContractEndReferenceData = {
          razon_social: socialReason || suppliesDetail?.RazonSocial || "",
          cif: cif,
          cups: codeCups.replace("ES", ""),
          direccion_suministro: splitAddress[0] || "",
          numero_suministro: splitAddress[1] || "",
          localidad_suministro: town || suppliesDetail?.Ciudad || "",
          provincia_suministro: suppliesDetail?.Provincia ?? "",
          cp_suministro: suppliesDetail?.CodPostal ?? "",
          fecha_solicitud: appliedDayFormatted,
        };

        const base64file =
          file &&
          (await getBase64(file).then(
            (res) => (res as string).split("base64,")[1],
          ));

        const validationResponse = await fetchBipValidation({
          document_type: "baja_cese",
          pdf_base64: base64file ?? "",
          reference_data: ocrValidationRequestBody,
        });

        if (
          (validationResponse as { detail?: string }).detail?.includes(
            "INVALID_DOCUMENT_TYPE",
          )
        ) {
          setOcrError("response_ko");
          return;
        }

        if (validationResponse.validation_result.message === "Validation ko") {
          setOcrError("response_ko");
          setOcrErrorMessageKeys(formatOcrErrorMessage(validationResponse));
          return;
        }
      } catch (error: any) {
        if (error?.status === 400) {
          setOcrError("response_ko");
        } else {
          setOcrError("server_error");
        }
        return;
      } finally {
        setIsOcrLoading(false);
      }

      setConfirmationModalOpen(true);
    }
  };

  const postCallCenter = async (
    incidenceText: string,
    ownerDataCupSelected: OwnerDataCups,
  ): Promise<void> => {
    const { contractCode, envirorment, idContract } = ownerDataCupSelected;

    let subtypeNumber = 0;
    switch (envirorment) {
      case "Luz":
        subtypeNumber = MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT;
        break;
      case "Gas":
        subtypeNumber = MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS;
        break;
      default:
        subtypeNumber = 0;
    }

    const managementMessage = `El usuario solicita el cierre de contrato.${
      incidenceText ? ` Detalle de la petición: ${incidenceText}` : ""
    }`;

    if (userData) {
      const IdTipoRegistro = getRegisterTypeId(
        envirorment,
        MANAGEMENTS_REGISTER_TYPE_REQUEST,
      );

      const requestBody: PostCallCenterRequestBody = {
        TextoIncidencia: managementMessage,
        CodigosContratos: [+contractCode],
        IdsContratos: [+idContract],
        IdTipoRegistro,
        IdSubTipoReclamacion: subtypeNumber,
        idUsuarioDestino: getRecipientId(
          IdTipoRegistro,
          subtypeNumber,
          isAgent,
        ),
        ClaveMedio: isAgent ? "09" : "12",
      };
      setIsClaimLoading(true);
      setStep(1);

      postCallCenterFetch(requestBody, userData.token)
        .then(([{ IdCallCenter, IdCarpetaIncidencias, Cups, EntornoBD }]) => ({
          IdCallCenter,
          IdCarpetaIncidencias,
          Cups,
          EntornoBD,
        }))
        .then(
          async ({ IdCallCenter, IdCarpetaIncidencias, Cups, EntornoBD }) => {
            if (IdCallCenter === 0) {
              throw new Error("One or more IdCallCenter values are 0");
            }

            const address = filteredCups?.find(
              (item) => item.codeCups === Cups,
            )?.address;

            file &&
              (await postImportDocument(
                IdCallCenter,
                IdCarpetaIncidencias,
                file,
                userData.token,
              ));

            setRequestState(MANAGEMENTS_STATE_PENDING);
            setRequestStateData(
              getManagementsRequestTypeData(
                MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
                MANAGEMENTS_STATE_PENDING,
                isAgent ?? false,
              ),
            );
            setManagementRequestInfo({
              registrarionDate: formatDate(new Date()),
              closingDate: formatDate(new Date()),
              refferenceNumber: IdCallCenter.toString(),
              cupsInfo: {
                cupsCode: Cups,
                address: address ?? "-",
                environment: EntornoBD,
              },
            });
            setIsClaimLoading(false);
          },
        )
        .catch((error) => {
          setRequestState(MANAGEMENTS_STATE_ERROR);
          setRequestStateData(
            getManagementsRequestTypeData(
              MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
              MANAGEMENTS_STATE_ERROR,
              isAgent ?? false,
            ),
          );
          setIsClaimLoading(false);
        });
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  useEffect(() => {
    if (!!ocrError) {
      setOcrError(null);
      setOcrErrorMessageKeys([]);
    }
  }, [file, checkBoxRadioValue, selectedDeliveryAddress]);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <Box
      component="section"
      className="last-managements"
      paddingBottom={{ md: "5rem" }}
    >
      <ManagementHeader
        title={"Baja por cese"}
        step={step}
        showStepper={true}
      />

      {step === 0 && (
        <Grid container justifyContent="center">
          <Grid item md={8} lg={7} flex={1}>
            <Stack
              bgcolor={{ md: "#fff" }}
              borderRadius="12px"
              boxShadow={{ md: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)" }}
              padding="3rem"
              marginY="2.5rem"
              gap="2rem"
            >
              <Stack width={{ xs: "100%", md: "50%" }}>
                <ConsumptionsManagementsDeliveryAddressComponent
                  ownerDataCups={filteredCups || []}
                  ownerDataCupSelected={selectedDeliveryAddress}
                  setOwnerDataCupSelected={(
                    ownerDataCupSelected: OwnerDataCups,
                  ) => {
                    setSupplyData(null);
                    setSelectedDeliveryAddress(ownerDataCupSelected);
                  }}
                />
              </Stack>
              <FormControl
                sx={{
                  display: "flex",
                  gap: "1rem",
                }}
              >
                <FormLabel htmlFor="claim-detail">
                  <Typography fontWeight={600}>
                    {t("Gestiones.Detalle su petición")}
                    <Typography variant="body2" component="span">
                      {" "}
                      - {t("Opcional")}
                    </Typography>
                  </Typography>
                </FormLabel>
                <TextField
                  className="claim-textfield"
                  value={contractEndDetail}
                  onChange={(e) => setcontractEndDetail(e.target.value)}
                  multiline
                  rows={7}
                />
              </FormControl>

              <Box component="div" paddingBottom="1.5rem">
                <Typography component="h3" variant="h3" paddingBottom="1.5rem">
                  {t("Gestiones.Día de aplicación")}
                </Typography>
                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1.5rem",
                    paddingBottom: "1.5rem",
                  }}
                  className="powers-radio"
                >
                  {appliedDayData.map(({ id, label, value }) => (
                    <FormControlLabel
                      key={id}
                      value={value}
                      label={t(`Gestiones.${label}`)}
                      onChange={() => setCheckBoxRadioValue(value)}
                      control={<Radio disableRipple />}
                    />
                  ))}
                </RadioGroup>
                <FormControl sx={{ gap: "0.5rem", alignItems: "start" }}>
                  <FormLabel htmlFor="dates">
                    <Typography fontWeight={600} variant="button">
                      {t(`Gestiones.Fecha de aplicación`)}
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                  </FormLabel>
                  <SingleDatePicker
                    maxDate={maxDate}
                    appliedDay={appliedDay}
                    setAppliedDay={setAppliedDay}
                    disabled={isDatePickerDisabled}
                    disablePast
                    error={error}
                    setError={setError}
                    customDateError={customDateError}
                  />

                  <Typography
                    variant="caption"
                    fontStyle={"italic"}
                    marginTop={1}
                  >
                    {t(`Gestiones.Fecha de aplicación supeditada`)}
                  </Typography>
                </FormControl>
              </Box>

              <ManagementUploadFile
                title={t("Gestiones.Anexo baja por cese de actividad")}
                isRequired={true}
                downloadButtonText={t("Gestiones.Descarga anexo cese")}
                downloadDocumentType="03"
                inputFileInstructions={false}
                onFileUpload={(id, file) => {
                  setFile(file);
                }}
                onFileRemove={(id) => {
                  setFile(null);
                }}
              />
              <div>
                {!!ocrError && (
                  <FormHelperText
                    error
                    sx={{
                      marginLeft: 0,
                      marginTop: "8px",
                      textAlign: "left",
                    }}
                  >
                    {ocrError === "response_ko"
                      ? t(
                          "Gestiones.Los datos del documento no coinciden con los registrados",
                        )
                      : t(
                          "Gestiones.Parece que ha habido un error, prueba de nuevo más tarde",
                        )}
                  </FormHelperText>
                )}
                {!!ocrError &&
                  ocrError === "response_ko" &&
                  ocrErrorMessage?.length > 0 && (
                    <FormHelperText
                      error
                      sx={{
                        marginLeft: 0,
                        marginTop: "8px",
                        textAlign: "left",
                      }}
                    >
                      <p>{t("Gestiones.Revise los siguientes campos")}</p>
                      <ul>
                        {ocrErrorMessage?.map((msg) => (
                          <li>{msg}</li>
                        ))}
                      </ul>
                    </FormHelperText>
                  )}
              </div>

              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  gap: "1rem",
                  marginY: "1.5rem",
                }}
              >
                <ButtonElement
                  onClick={() => handleValidateFile()}
                  disabled={isButtonDisabled}
                  isLoading={isOcrLoading}
                >
                  {t("Gestiones.Solicitar baja")}
                </ButtonElement>
                <ButtonElement type="button" secondary onClick={openModal}>
                  {t("Cancelar")}
                </ButtonElement>
              </FormControl>
            </Stack>
            <ManagementsCancelProcess
              open={isModalOpen}
              handleClose={closeModal}
            />
            <ManagementsContractEndModal
              open={isConfirmationModalOpen}
              handleClose={() => setConfirmationModalOpen(false)}
              onAccept={() => handleSendContractEnd()}
              environment={selectedDeliveryAddress.envirorment}
            />
          </Grid>
        </Grid>
      )}
      {[1, 2, 3].includes(step) && (
        <ManagementsRequestState
          state={requestState}
          isLoading={isClaimLoading}
          managementRequestInfo={managementRequestInfo}
          showManagementRequestInfo
          title={requestStateData.title}
          description={requestStateData.description}
          descriptionExtra={requestStateData.descriptionExtra}
          cupsInfo={managementRequestInfo.cupsInfo}
        />
      )}
    </Box>
  );
};

export default ManagementsContractEnd;
